/**
 * UI copy never shows an em dash (W-L3). Labels the server stores and the app only displays -
 * permission names seeded as "View Submissions — Daily Log (RB)" - are normalised at render
 * time, because the seed only creates missing rows and existing databases keep the old text.
 * Not for user-entered content (notes, descriptions people typed), which is shown as written.
 */
export function uiDash(text: string): string;
export function uiDash(text: string | null | undefined): string | null | undefined;
export function uiDash(text: string | null | undefined): string | null | undefined {
  return typeof text === 'string' ? text.replace(/—/g, '–') : text;
}

/**
 * V2-060: a sentence that quotes someone's comment ends with exactly one stop. "Fix the lines
 * – Wrong rate." reads "Fix the lines – Wrong rate." not "Fix the lines – Wrong rate..";
 * a comment ending in ? or ! keeps its own mark.
 */
export function endSentence(text: string): string {
  const trimmed = text.trimEnd();
  return /[.!?…]$/.test(trimmed) ? trimmed : `${trimmed}.`;
}
